import styled from "styled-components";
import deleteLogo from "../../assets/images/icons/ic_delete.svg";
import deleteLogoBlue from "../../assets/images/icons/ic_delete_blue.svg";
import caretDownIcon from "../../assets/images/icons/ic_caret_down.svg";
import * as Variable from "../../CSSVariables";

export const BagItemStyle = styled.div`
  display: flex;
  justify-content: center;
  padding: 22px 0 0;
  position: relative;

  &:last-child {
  }
  @media only screen and (min-width: ${Variable.mobile}) {
    padding: 28px 0;
  }
  p {
    margin-top: 0;
    margin-bottom: 12px;
  }

  border-bottom: 1px solid ${Variable.alto};

  > div {
    vertical-align: top;
    margin-left: 20px;
    flex: auto;
  }
  .lazyload-wrapper {
    margin: 0;
    min-width: 50px;
    width: 50px;
    max-width: 50px;

    @media only screen and (min-width: ${Variable.mobile}) {
      min-width: 70px;
      width: 70px;
      max-width: 70px;
    }
    @media only screen and (min-width: ${Variable.tabletLandscape}) {
      min-width: 120px;
      width: 120px;
      max-width: 120px;
    }
  }
  .item-img {
    height: auto;
    width: 100%;

    @media only screen and (min-width: ${Variable.mobile}) {
    }
    @media only screen and (min-width: ${Variable.tablet}) {
    }
  }
  .details {
    width: 50%;
    text-align: left;
    > * {
      margin-bottom: 1.2rem;

      @media only screen and (min-width: ${Variable.tablet}) {
        margin-bottom: 2.2rem;
      }
    }
    .details-title {
      margin: 0;
      color: ${Variable.black};
      font-weight: ${Variable.semiBold};
      line-height: 24px;

      @media only screen and (min-width: ${Variable.mobile}) {
        line-height: 20px;
      }
      @media only screen and (min-width: ${Variable.desktop}) {
        font-size: 2rem;
      }
      @media only screen and (min-width: ${Variable.largeDesktop}) {
        margin-top: -4px;
        line-height: 26px;
      }
      &:hover {
        text-decoration: underline;
        color: ${Variable.scienceBlue};
      }
    }
    .details-isbn {
      line-height: 24px;
      @media only screen and (min-width: ${Variable.mobile}) {
        line-height: unset;
      }
      span {
        margin: 0 8px;
        display: none;

        @media only screen and (min-width: ${Variable.mobile}) {
          display: inline-block;
        }
      }
      br {
        @media only screen and (min-width: ${Variable.mobile}) {
          display: none;
        }
      }
    }
    .price-each {
      margin-bottom: 22px;

      @media only screen and (min-width: ${Variable.mobile}) {
        margin-bottom: 0;
      }
      @media only screen and (min-width: ${Variable.desktop}) {
        font-size: 2.2rem;
      }

      .discount-code {
        text-transform: uppercase;
        background-color: ${Variable.success};
        color: #fff;
        padding: 0.3rem 0.5rem;
        margin-left: 1.2rem;
        font-size: 1.2rem;
        vertical-align: middle;
      }
    }
  }
`;

export const OrigPrice = styled.div`
  display: inline-block;
  text-decoration: line-through;
  color: ${Variable.boulder};
`;
export const DiscountPrice = styled.div`
  display: inline-block;
  margin-left: 20px;
  color: ${Variable.success};
  font-weight: ${Variable.semiBold};
`;
export const QuantityStyle = styled.div`
  select {
    padding: 12px 34px 12px 18px;
    font-weight: ${Variable.semiBold};
    border: 0;
    background-color: ${Variable.mystic};
    border-radius: 4px;
    appearance: none;
    background-image: url(${caretDownIcon});
    background-size: 20%;
    background-repeat: no-repeat;
    background-position: right 12px center;
  }
`;
export const QuantityDisabledStyle = styled.div`
  display: block;
  span {
    padding: 12px 12px 12px 48px;
    font-weight: ${Variable.semiBold};
    border: 0;
    background-color: ${Variable.mystic};
    border-radius: 4px;
    text-align: right;
    display: inline-block;
    cursor: default;
  }
`;

export const HiddenLabelStyle = styled.label`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 0;
  height: 0;
  overflow: hidden;
`;

export const ActionsStyle = styled.div`
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;

  @media only screen and (min-width: ${Variable.mobile}) {
    position: static;
    bottom: 6px;
    right: 0;
  }

  > * {
    margin-bottom: 1.2rem;

    &:last-child {
      margin-bottom: 2.2rem;
    }
    @media only screen and (min-width: ${Variable.tablet}) {
      margin-bottom: 2.2rem;
    }
  }
`;
export const ItemSubTotalStyle = styled.p`
  font-weight: ${Variable.semiBold};

  @media only screen and (min-width: ${Variable.desktop}) {
    font-size: 3rem;
  }
`;

export const DeleteStyle = styled.button`
  background-image: url(${deleteLogo});
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  border: 0;
  padding: 12px;
  font-size: 0;
  background-color: transparent;
  cursor: pointer;
  // transition: all 0.1s;

  &:hover {
    background-image: url(${deleteLogoBlue});
  }
`;
